import { render, staticRenderFns } from "./MessagePreview.vue?vue&type=template&id=95508f12&scoped=true&"
import script from "./MessagePreview.vue?vue&type=script&lang=js&"
export * from "./MessagePreview.vue?vue&type=script&lang=js&"
import style0 from "./MessagePreview.vue?vue&type=style&index=0&id=95508f12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95508f12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardTitle})
